export default "__VITE_ASSET__COPO_VyG__"